import React, { useEffect, useState } from "react";
import Card from "./Card";
import Navbar2 from "./Navbar";
import sala1 from "../assets/t1Sala1.jpg";
import sala2 from "../assets/t1Sala2.jpg";
import sala3 from "../assets/t1Sala3.jpg";
import sala4 from "../assets/t1Sala4.jpg";
import Comedor from "../assets/t1Comedor.jpg";
import "../torre1-cards.css";

const api = process.env.REACT_APP_API;

const cards = [
  {
    id: 1,
    Nombre: "Sala 1",
    Edificio: "Torre1",
    N_piso: "10",
    Tamaño: "Mediana",
    N_personas: "12",
    Estado: "Disponible",
    img: sala1,
    img2: sala1,
  },
  {
    id: 2,
    Nombre: "Sala 2",
    Edificio: "Torre1",
    N_piso: "10",
    Tamaño: "Mediana",
    N_personas: "12",
    Estado: "Disponible",
    img: sala2,
    img2: sala2,
  },
  {
    id: 33,
    Nombre: "Sala 3",
    Edificio: "Torre1",
    N_piso: "10",
    Tamaño: "Mediana",
    N_personas: "10",
    Estado: "No Disponible",
    img: sala3,
    img2: sala3,
  },
  {
    id: 32,
    Nombre: "Sala 4",
    Edificio: "Torre1",
    N_piso: "10",
    Tamaño: "Grande",
    N_personas: "18",
    Estado: "No Disponible",
    img: sala4,
    img2: sala4,
  },  {
    id: 34,
    Nombre: "Sala 1",
    Edificio: "Torre 1",
    N_piso: "18",
    Tamaño: "Grande",
    N_personas: "24",
    Estado: "Disponible",
    img: sala1,
    img2: sala1,
  },
  
  {
    id: 35,
    Nombre: "Sala 2",
    Edificio: "Torre 1",
    N_piso: "18",
    Tamaño: "Grande",
    N_personas: "24",
    Estado: "Disponible",
    img: sala1,
    img2: sala1,
  }
  ,{
    id: 36,
    Nombre: "Sala 3",
    Edificio: "Torre 1",
    N_piso: "18",
    Tamaño: "Grande",
    N_personas: "24",
    Estado: "Disponible",
    img: sala1,
    img2: sala1,
  },
  {
    id: 28,
    Nombre: "Comedor",
    Edificio: "Torre1",
    N_piso: "17",
    Tamaño: "Grande",
    N_personas: "90",
    Estado: "Disponible",
    img: Comedor,
    img2: Comedor,
  }
  ];

function Cards() {
  const [estadoPorId, setEstadoPorId] = useState({});

  useEffect(() => {
    const cargarEstados = async () => {
      try {
        const res = await fetch(`${api}/salas`);
        const data = await res.json();
        const mapa = {};
        (Array.isArray(data) ? data : []).forEach((s) => {
          mapa[s.id_Sala] = String(s.estado || "Disponible").trim();
        });
        setEstadoPorId(mapa);
      } catch (e) {
        console.error(e);
      }
    };
    cargarEstados();
  }, []);

  return (
    <div className="rs-t1-page">
      <Navbar2 />
      <section className="rs-t1-hero">
        <h2>Torre 1</h2>
        <p>Selecciona la sala que necesitas y crea tu solicitud en segundos.</p>
      </section>

      <div className="rs-t1-grid">
        {cards.map((card) => {
          const estado = estadoPorId[card.id] ?? card.Estado;
          return (
            <article className="rs-t1-item" key={card.id}>
              <Card
                id={card.id}
                Nombre={card.Nombre}
                Edificio={card.Edificio}
                N_piso={card.N_piso}
                Tamaño={card.Tamaño}
                N_personas={card.N_personas}
                Estado={estado}
                img={card.img}
                img2={card.img2}
              ></Card>
            </article>
          );
        })}
      </div>
    </div>
  );
}

export default Cards;
